module.exports = __webpack_public_path__ + "static/media/icon-award-03.48c1ab01.svg";